export const pinCode =
`
  <AddressMap
    center={{ lat: 41.549402, lng: -8.422407 }}
    marker={marker}
    withLegend
    tooltipContent={renderAddressMapTooltip}
  />
`;

export const popAndLegendCode =
`
  <AddressMap
    center={{ lat: 41.549402, lng: -8.422407 }}
    marker={marker}
    clusters={addressClusters}
    withLegend
    tooltipContent={renderAddressMapTooltip}
  />
`;

export const clusterAndLegendCode =
`
  <CountryMap
    center={{ lat: 52.076604, lng: -0.522302 }}
    zoom={5}
    clusters={countryClusters}
    withLegend
  />
`;

export const orderLinesCode =
`
  <CountryMap
    center={{ lat: 38.505504, lng: 30.638125 }}
    orders={countryOrders}
    tooltipContent={renderCountryMapTooltip()}
  />
`;





// WEBPACK FOOTER //
// ./src/containers/components/Map/constants/mapsCode.js